import React from "react";
import {
  FormControl,
  InputLabel,
  Select,
  MenuItem,
  SelectChangeEvent,
  FormHelperText,
} from "@mui/material";
import KeyboardArrowDownIcon from "@mui/icons-material/KeyboardArrowDown";

interface Props {
  LabelName: string;
  menuItems: any;
  name: any;
  value: any;
  handleChange: any;
  error: any;
  helperText: any;
  setOthers?: any | undefined;
  disabled?: any;
  onBlur?: any;
}

const CommonDropdown: React.FC<Props> = ({
  LabelName,
  menuItems,
  name,
  value,
  handleChange,
  error,
  helperText,
  setOthers,
  disabled,
  onBlur,
}) => {
  // console.log("value",value)

  return (
    <FormControl fullWidth>
      <InputLabel
        id="demo-simple-select-label"
        sx={{
          color: "#6B7280",
          fontWeight: 400,
          fontSize: "14px",
          "&.MuiFormLabel-filled": {
            color: "#111827",
            fontWeight: 400,
            fontSize: "15px",
          },
        }}
      >
        {LabelName}
      </InputLabel>
      <Select
        labelId="demo-simple-select-label"
        id="demo-simple-select"
        value={value}
        name={name}
        disabled={disabled}
        label={LabelName}
        error={error}
        onChange={(e) => {
          // console.log(e.target.value.value);
          if (e.target.value.value && setOthers) {
            //  console.log(e.target.value);
            setOthers(e.target.value.value);
          }

          handleChange(e);
        }}
        onBlur={onBlur}
        IconComponent={(props) => (
          <KeyboardArrowDownIcon
            style={{ marginRight: "10px", color: "#000" }}
            {...props}
          />
        )}
        MenuProps={{
          PaperProps: {
            sx: {
              borderRadius: "10px",
              "& li.Mui-selected": {
                backgroundColor: "#1F2937",
                color: "white",
              },
            },
          },
          MenuListProps: {
            sx: {
              "& .MuiPaper-root": {
                borderRadius: "10px",
              },

              "& li.Mui-selected": {
                backgroundColor: "#1F2937",
                color: "white",
                "&:hover": {
                  backgroundColor: "#1F2937",
                  color: "white",
                },
              },
            },
          },
        }}
        sx={{
          fieldset: {
            borderColor: "#E5E7EB",
            borderRadius: "100px",
          },
          color: "#6B7280",
          fontSize: "14px",
          // "& .MuiSelect-icon": {
          //   paddingRight: "10px",
          //   "&::after": {
          //     paddingRight: "10px",
          //   },
          // },
        }}
      >
        {menuItems.map((a: any, index: any) => {
          return (
            <MenuItem
              key={index}
              value={a}
              selected={a === value}
              sx={{ background: "white" }}
            >
              {a.value}
            </MenuItem>
          );
        })}
      </Select>
      {/* <div style={{fontSize:'12px', color:'red'}}> {helperText}</div> */}
      <FormHelperText style={{ color: "#d32f2f" }}>{helperText}</FormHelperText>
    </FormControl>
  );
};
export default CommonDropdown;
